// extracted by mini-css-extract-plugin
export var askAiIcon = "_m6-9";
export var container = "_m6-0";
export var groupSeparator = "_m6-a";
export var highlight = "_m6-4";
export var resultIcon = "_m6-5";
export var resultItem = "_m6-7";
export var resultSubtitle = "_m6-3";
export var resultTitle = "_m6-2";
export var resultsList = "_m6-1";
export var searchGroup = "_m6-6";
export var selected = "_m6-8";